import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, normalizeClass as _normalizeClass, Teleport as _Teleport, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "flex flex-col h-full" };
const _hoisted_2 = { class: "oasis-sidebar-header" };
const _hoisted_3 = ["href"];
const _hoisted_4 = {
    class: "oasis-sidebar-menu",
    "aria-label": "Main navigation"
};
const _hoisted_5 = { class: "oasis-sidebar-footer" };
const _hoisted_6 = { class: "oasis-curtin-logo" };
const _hoisted_7 = {
    href: "https://www.curtin.edu.au/",
    "aria-label": "Curtin University logo"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
    key: 0,
    ref: "toggleContainerEle",
    tabindex: "-1",
    class: "oasis-sidebar-toggle"
};
const _hoisted_10 = ["href"];
import PButton from 'primevue/button';
import { onMounted, onBeforeUnmount, shallowRef, nextTick } from 'vue';
import { debounce } from '@fiksu/core';
import CloseIcon from '../assets/icons/close.svg';
import LogoutIcon from '../assets/icons/logout.svg';
import MenuIcon from '../assets/icons/menu.svg';
import OasisLogoIcon from '../assets/icons/oasis-logo.svg';
import NamedIcon from './named-icon.vue';
import SidebarMenuSection from './sidebar-menu-section.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'oasis-sidebar',
    props: {
        toggleContainer: { default: undefined },
        curtinLogoUrl: { default: '//global.curtin.edu.au/responsive-assets/img/logo-curtin-university.png' },
        siteName: { default: 'OASIS' },
        siteUrl: { default: '/' },
        menu: { default: () => [] }
    },
    emits: ['update:state'],
    setup(__props) {
        const sidebarEle = shallowRef(null);
        const openButtonEle = shallowRef(null);
        const closeButtonEle = shallowRef(null);
        const isOpenSidebar = shallowRef(false);
        let lastWindowWidth = window.innerWidth;
        const getElement = (target) => {
            return target && '$el' in target ? target.$el : target;
        };
        const focusElement = async (target) => {
            await nextTick();
            const element = getElement(target);
            if (element instanceof HTMLElement) {
                element.focus();
            }
        };
        const focusSidebar = () => focusElement(sidebarEle.value);
        const focusOpenButton = () => focusElement(openButtonEle.value);
        const focusCloseButton = () => focusElement(closeButtonEle.value);
        const closeSidebar = async () => {
            isOpenSidebar.value = false;
            await focusOpenButton();
        };
        const openSidebar = async () => {
            isOpenSidebar.value = true;
            setTimeout(() => focusCloseButton(), 300);
        };
        const onResize = debounce(() => {
            const currentWidth = window.innerWidth;
            if (currentWidth !== lastWindowWidth && isOpenSidebar.value) {
                lastWindowWidth = currentWidth;
                isOpenSidebar.value = false;
            }
        }, 200);
        const getFocusableElements = () => {
            if (!sidebarEle.value)
                return [];
            const selectors = [
                'a[href]',
                'button:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            return Array.from(sidebarEle.value.querySelectorAll(selectors))
                .filter(el => !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length));
        };
        const handleWindowKeydown = (ev) => {
            if (ev.key === 'Escape' || ev.key === 'Esc') {
                if (isOpenSidebar.value) {
                    ev.preventDefault();
                    closeSidebar();
                }
                return;
            }
            if (ev.key === 'Tab' && isOpenSidebar.value) {
                const focusable = getFocusableElements();
                if (focusable.length === 0) {
                    ev.preventDefault();
                    focusSidebar();
                    return;
                }
                const first = focusable[0];
                const last = focusable[focusable.length - 1];
                const active = document.activeElement;
                if (ev.shiftKey) {
                    if (active === first || active === sidebarEle.value) {
                        ev.preventDefault();
                        last.focus();
                    }
                }
                else {
                    if (active === last) {
                        ev.preventDefault();
                        first.focus();
                    }
                }
            }
        };
        onMounted(() => {
            lastWindowWidth = window.innerWidth;
            window.addEventListener('resize', onResize);
            window.addEventListener('keydown', handleWindowKeydown);
        });
        onBeforeUnmount(() => {
            window.removeEventListener('resize', onResize);
            window.removeEventListener('keydown', handleWindowKeydown);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass({ 'oasis-sidebar-overlay': isOpenSidebar.value }),
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (closeSidebar()), ["self", "prevent"]))
            }, [
                _createElementVNode("div", {
                    ref_key: "sidebarEle",
                    ref: sidebarEle,
                    class: _normalizeClass(["oasis-sidebar-wrapper focus:outline-none", { 'active': isOpenSidebar.value }]),
                    tabindex: "-1"
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            (_ctx.toggleContainer)
                                ? (_openBlock(), _createBlock(_unref(PButton), {
                                    key: 0,
                                    ref_key: "closeButtonEle",
                                    ref: closeButtonEle,
                                    "aria-label": "Close menu",
                                    class: "sidebar-button",
                                    severity: "tertiary",
                                    variant: "outlined",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (closeSidebar()))
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(NamedIcon, {
                                            class: "rotate-90",
                                            name: _unref(CloseIcon).id
                                        }, null, 8, ["name"])
                                    ]),
                                    _: 1
                                }, 512))
                                : _createCommentVNode("", true),
                            _createElementVNode("a", {
                                class: "oasis-logo",
                                href: _ctx.siteUrl,
                                "aria-label": "OASIS logo"
                            }, [
                                _createVNode(NamedIcon, {
                                    class: "oasis-logo-icon",
                                    name: _unref(OasisLogoIcon).id
                                }, null, 8, ["name"])
                            ], 8, _hoisted_3)
                        ]),
                        _createElementVNode("nav", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item) => {
                                return (_openBlock(), _createBlock(SidebarMenuSection, _mergeProps({
                                    key: item.label
                                }, { ref_for: true }, item, {
                                    "onUpdate:toggled": ($event) => (_ctx.$emit('update:state', { label: item.label, isExpanded: $event }))
                                }), null, 16, ["onUpdate:toggled"]));
                            }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(_unref(PButton), {
                                as: "a",
                                href: "/auth/logoff",
                                variant: "link",
                                class: "sidebar-link-button",
                                "aria-label": "Logout"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(NamedIcon, {
                                        name: _unref(LogoutIcon).id
                                    }, null, 8, ["name"]),
                                    _cache[3] || (_cache[3] = _createElementVNode("span", null, "Log out", -1))
                                ]),
                                _: 1,
                                __: [3]
                            }),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("a", _hoisted_7, [
                                    _createElementVNode("img", {
                                        src: _ctx.curtinLogoUrl,
                                        alt: "Curtin University logo"
                                    }, null, 8, _hoisted_8)
                                ])
                            ])
                        ])
                    ])
                ], 2),
                (_openBlock(), _createBlock(_Teleport, {
                    defer: "",
                    to: _ctx.toggleContainer,
                    disabled: !_ctx.toggleContainer
                }, [
                    (_ctx.toggleContainer)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_unref(PButton), {
                                ref_key: "openButtonEle",
                                ref: openButtonEle,
                                "aria-label": "Menu",
                                class: "sidebar-button",
                                severity: "tertiary",
                                variant: "outlined",
                                onClick: _cache[1] || (_cache[1] = ($event) => (openSidebar()))
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(NamedIcon, {
                                        name: _unref(MenuIcon).id
                                    }, null, 8, ["name"])
                                ]),
                                _: 1
                            }, 512),
                            _createElementVNode("a", {
                                class: "oasis-logo",
                                href: _ctx.siteUrl,
                                "aria-label": "OASIS logo"
                            }, [
                                _createVNode(NamedIcon, {
                                    class: "oasis-logo-icon",
                                    name: _unref(OasisLogoIcon).id
                                }, null, 8, ["name"])
                            ], 8, _hoisted_10)
                        ], 512))
                        : _createCommentVNode("", true)
                ], 8, ["to", "disabled"]))
            ], 2));
        };
    }
});
